/* Live Free signup popup. The only script on the homepage. Deferred.
   Without JS the popup never appears, which is the correct failure. */
(function () {
  var el = document.querySelector('[data-lf-popup]');
  if (!el) return;

  var KEY = 'lf_popup_dismissed_at';
  var delay = (parseInt(el.getAttribute('data-delay'), 10) || 20) * 1000;
  var scrollPct = (parseInt(el.getAttribute('data-scroll'), 10) || 40) / 100;
  var suppressMs = (parseInt(el.getAttribute('data-suppress'), 10) || 30) * 86400000;

  var shown = false;
  var lastFocus = null;
  var timer = null;
  var raf = 0;

  function suppressed() {
    try {
      return Date.now() - Number(localStorage.getItem(KEY) || 0) < suppressMs;
    } catch (e) {
      return false;
    }
  }

  function show() {
    if (shown || suppressed()) return;
    shown = true;
    teardown();
    lastFocus = document.activeElement;
    el.hidden = false;
    var focusable = el.querySelector('input, button');
    if (focusable) focusable.focus();
    document.addEventListener('keydown', onKey);
  }

  function dismiss() {
    el.hidden = true;
    document.removeEventListener('keydown', onKey);
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') dismiss();
  }

  // rAF-throttled, and only acts when the threshold is actually crossed.
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var doc = document.documentElement;
      var range = doc.scrollHeight - doc.clientHeight;
      if (range > 0 && window.scrollY / range > scrollPct) show();
    });
  }

  function teardown() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    if (raf) cancelAnimationFrame(raf);
  }

  var close = el.querySelector('[data-lf-popup-close]');
  if (close) close.addEventListener('click', dismiss);

  if (suppressed()) return;
  timer = setTimeout(show, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
